import React, { VFC } from 'react';
import { Col, Container } from 'react-grid-system';

import { useOrderContext } from '../contexts/orderContext';
import SectionHeader from '../components/organisms/SectionHeader';
import OrderBody from '../components/organisms/OrderBody';

import Loader from '../components/molecules/Loader';
import SurroundingBorder from '../components/organisms/SurroundingBorder';
import ListBorder from '../components/organisms/ListBorder';

import OrderLine from '../components/organisms/OrderLine';
import Spacing from '../components/atoms/Spacing';
import MissingData from '../components/molecules/MissingData';

const OrderReturnPage: VFC = () => {
  const {
    defaultOrder,
    orders,
    loading: loadingOrder,
    search,
  } = useOrderContext();
  const selectedOrder = orders?.find(
    (item) => item.orderNumber === defaultOrder,
  );

  const filtered = search
    ? selectedOrder?.orderLines?.filter((line) =>
        JSON.stringify(line).includes(search),
      )
    : selectedOrder?.orderLines;

  return (
    <SurroundingBorder>
      <SectionHeader {...selectedOrder} />
      {loadingOrder ? (
        <Loader color="gray" />
      ) : (
        <div>
          {!selectedOrder && !loadingOrder ? (
            <MissingData translationKey="no_order_data" />
          ) : (
            <>
              <OrderBody {...selectedOrder} />
              <Container>
                <ListBorder>
                  <Col>
                    <Spacing spacing={4} />
                    {filtered?.map((item) => (
                      <OrderLine key={item.uid} {...item} />
                    ))}
                  </Col>
                </ListBorder>
              </Container>
            </>
          )}
        </div>
      )}
    </SurroundingBorder>
  );
};

export default OrderReturnPage;
